import React from "react"
import Feature from "../shared/top/Feature"
import HeadingM from "../shared/HeadingM"

const TopFeature = () => {
  const items = [
    {
      title: "音楽療法で、心も体も元気に",
      descriptions: [
        "音楽療法を通じて、リズムや音に親しみながら、感情表現や身体の動きが自然に育まれます。仲間と音を共有する体験が、心の安定や社会性にもつながります。",
      ],
    },
    {
      title: "好奇心と考える力を育てる",
      descriptions: [
        "機械の分解・組み立てなどの体験を通じて、探究心や集中力、手先の器用さを育てます。論理的に考える力が身につき、将来の学びにもつながります。",
      ],
    },
    {
      title: "1日のはじまりとおわりを大切に",
      descriptions: [
        "「朝の会」と「帰りの会」で、健康チェックやふりかえりを行い、生活リズムや基本的生活習慣を身につけます。集団の中での安心感も育まれます。",
      ],
    },
    {
      title: "運動と感覚で「できた！」を積み重ねる",
      descriptions: [
        "体を動かし、感覚を使う遊びで運動機能を伸ばします。一人ひとりの特性に合わせ、無理なく挑戦できる環境を整えています。",
      ],
    },
    {
      title: "個別課題で学ぶ力と自信を育てる",
      descriptions: [
        "色や形、数の認識など、子どもに合わせた課題で認知力や自己理解を深めます。「自分でできた」が自信につながります。",
      ],
    },
    {
      title: "集団活動と外出で社会性を育む",
      descriptions: [
        "みんなと遊ぶ・出かける体験を通して、ルールやマナー、相手への思いやりを学びます。人との関わりが自然に増えていきます。",
      ],
    },
  ]

  return (
    <div className="mt-24">
      <HeadingM title="すてあの特徴" target="sutea" />
      <Feature items={items} target="sutea" />
    </div>
  )
}

export default TopFeature
